/* The short "needs attention" table that sits under the charts.

   Not a Reactable: this is a fixed, server-ranked shortlist of at most a dozen
   rows with no paging, sorting or filtering. Reactable would bring a toolbar,
   a filter sidebar and a pager that have nothing to act on here. */
import { cn } from "../../utils/tailwindUtils";

const HEAD_CELL_CLASS = "pb-2 text-[11px] font-bold uppercase tracking-wide text-muted-foreground";

export const DashboardTable = ({
    columns,
    rows = [],
    onRowClick,
    rowKey = (row) => row.id,
    empty = "Nothing to show.",
    minWidth = "min-w-[640px]",
}) => {
    if (!rows.length) {
        return <p className="text-sm text-muted-foreground">{empty}</p>;
    }

    const clickable = typeof onRowClick === "function";

    return (
        <div className="overflow-x-auto">
            <table className={cn("w-full text-sm", minWidth)}>
                <thead>
                    <tr className="border-b border-gray-100 text-left dark:border-gray-800">
                        {columns.map((col) => (
                            <th key={col.key} className={cn(HEAD_CELL_CLASS, col.headClassName)}>
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr
                            key={rowKey(row)}
                            // A clickable row has to answer to the keyboard too. Without
                            // these three attributes the drill-through exists for mouse
                            // users only, which is how the pattern usually ships.
                            {...(clickable
                                ? {
                                    role: "button",
                                    tabIndex: 0,
                                    onClick: () => onRowClick(row),
                                    onKeyDown: (event) => {
                                        if (event.key === "Enter" || event.key === " ") {
                                            event.preventDefault();
                                            onRowClick(row);
                                        }
                                    },
                                }
                                : {})}
                            className={cn(
                                "border-b border-gray-50 dark:border-gray-800/60",
                                clickable &&
                                "cursor-pointer hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sidebar-primary dark:hover:bg-gray-800/40",
                            )}
                        >
                            {columns.map((col) => (
                                <td key={col.key} className={cn("py-2", col.className)}>
                                    {col.render ? col.render(row) : (row[col.key] ?? "—")}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
